const reactdata = [
  {
    question: "What is a state in React?",
    incorrectAnswers: [
      "External storage of the component",
      "A permanent storage",
      "None",
    ],
    correctAnswer: "Internal storage of the component",
  },
  {
    question: "Does React.js create a VIRTUAL DOM in the memory?",
    incorrectAnswers: ["None", "False", "Cannot say"],
    correctAnswer: "True",
  },
  {
    question:
      "Which of the following is used to pass data to a component from outside in React.js?",
    incorrectAnswers: ["setState", "propTypes", "Render with arguments"],
    correctAnswer: "props",
  },
  {
    question: "What are the two ways to handle data in React?",
    incorrectAnswers: [
      "State & Services",
      "State & Component",
      "Services & Components",
    ],
    correctAnswer: "State & Props",
  },
  {
    question: "What does ES6 stand for?",
    incorrectAnswers: ["ECMAJavaScript 6", "ECMA 6", "EJavaScript 6"],
    correctAnswer: "ECMAScript 6",
  },
  {
    question:
      "Which of the following function is used to change the state of the React.js component?",
    incorrectAnswers: ["this.setChangeState", "this.State{}", "None"],
    correctAnswer: "this.setState",
  },
  {
    question:
      "Which of the following is a must API for every React.js component?",
    incorrectAnswers: ["Setinitial Component", "render", "All"],
    correctAnswer: "render Component",
  },
  {
    question:
      "Which of the following method refers to the parent class in React.js?",
    incorrectAnswers: ["this()", "self()", "inherits()"],
    correctAnswer: "super()",
  },
  {
    question:
      "Which of the following statement is true for uncontrolled components in React.js?",
    incorrectAnswers: [
      "The source of truth is a component state",
      "The source of truth can be anything",
      "None",
    ],
    correctAnswer: "The source of truth is DOM",
  },
  {
    question:
      "What will happen if you render an input element with disabled = {false}?",
    incorrectAnswers: [
      "It will not be rendered at all",
      "It will be rendered as disabled",
      "None",
    ],
    correctAnswer: "It will be rendered as enabled",
  },
  {
    question:
      "Which of the following statement is true for controlled components in React.js?",
    incorrectAnswers: [
      "The source of truth can be anything",
      "The source of truth is DOM",
      "None",
    ],
    correctAnswer: "The source of truth is a component state",
  },
  {
    question:
      "Which of the following lifecycle events React components have at the highest level?",
    incorrectAnswers: [
      "Initialization",
      "State/Property Updates",
      "Destruction",
    ],
    correctAnswer: "All",
  },
  {
    question: "Why is the usage of set State?",
    incorrectAnswers: [
      "Access the previous state before the set State operation",
      "Replace the state completely instead of the default merge action",
      "None",
    ],
    correctAnswer: "Invoke code after the set State operation is done",
  },
  {
    question:
      "Which of the following acts as the input of a class-based component?",
    incorrectAnswers: ["Factory", "Render", "Class"],
    correctAnswer: "props",
  },
  {
    question:
      "Which of the following keyword is used to create a class inheritance?",
    incorrectAnswers: ["Inherits", "Create", "None"],
    correctAnswer: "Extends",
  },
  {
    question: "How can you set a default value for an uncontrolled form field?",
    incorrectAnswers: [
      "By using the default property",
      "By using the value property",
      "It is assigned automatically",
    ],
    correctAnswer: "By using the defaultValue property",
  },
  {
    question:
      "What is the declarative way to render a dynamic list of components based on values in an array?",
    incorrectAnswers: [
      "With a for/while loop",
      "Using the <Each /> component",
      "Using the reduce array method",
    ],
    correctAnswer: "Using the Array.map() method",
  },
  {
    question:
      "Which of the following API is a MUST for every ReactJS component?",
    incorrectAnswers: ["getInitialState", "render", "None"],
    correctAnswer: "renderComponent",
  },
  {
    question:
      "At the highest level, React components have lifecycle events that fall into",
    incorrectAnswers: [
      "Initialization",
      "Destruction",
      "State/Property Updates",
    ],
    correctAnswer: "All",
  },
  {
    question:
      "How can you access the state of a component from inside of a member function?",
    incorrectAnswers: [
      "this.getState()",
      "this.prototype.stateValue",
      "this.state",
    ],
    correctAnswer: "this.values",
  },
];

export default reactdata;
